export default __webpack_public_path__ + "static/media/Shendoh of Conflagrant Flame.93e95fef.jpg";